// A drop that lands just outside a drop zone still hits the document, and the
// browser's default there is to navigate to the dropped file — the upload dialog
// disappears and the PDF opens instead. While an upload surface is on screen we
// swallow those near-miss drops so the worst case is "nothing happened".

import { useEffect } from 'react';

export const useBlockStrayFileDrop = (active: boolean): void => {
  useEffect(() => {
    if (!active) return;

    const swallow = (e: DragEvent) => {
      // Only file drags — text/link drags into inputs must keep working.
      if (!e.dataTransfer?.types?.includes('Files')) return;
      e.preventDefault();
    };

    window.addEventListener('dragover', swallow);
    window.addEventListener('drop', swallow);
    return () => {
      window.removeEventListener('dragover', swallow);
      window.removeEventListener('drop', swallow);
    };
  }, [active]);
};
